<section class="filters" id='filters-list'>
  @if (isMobile) {
    <div class="filters__header">
      <mb-icon icon="x-close" (click)="closeFilters.emit()"></mb-icon>
    </div>
  }
  <div class="filters__list">
    @if (appliedFilters?.length && showAppliedFilters) {
      <am-applied-filter-list [appliedFilters]="appliedFilters" [isMobile]="isMobile"
        (filterRemoved)="changeFilter(false, $event?.type, $event?.item, true)"
        (allFiltersRemoved)="removeAll()"></am-applied-filter-list>
    } @else {
      <div class="filters__title" i18n="@@filters__title">Filtros</div>
    }
    @for (filter of filtersList; track filter; let i = $index; let isLast = $last) {
      @switch (filter.type) {
        @case ('FLEXIBLE') {
          @if (brand) {
            <am-card-filter [type]="filter.type" icon="calerdar-clock"
              [showPopover]="!appliedFilters?.length && !isMobile" [brand]="brand">
              <div class="flexible-filter__content">
                <mb-switch class="flexible-filter__switch" [value]="filter.value"
                  (change)="changeValueSwitch($event?.target, filter.type, {code: 'FLEXIBLE', description: 'FLEXIBLE', count: 1, type: filter.type  })">
                </mb-switch>
                <div class="flexible-filter__label">
                  <span i18n="@@flexiblerate__filter__text">Ver sólo alojamientos con cancelación gratuita</span>
                </div>
              </div>
            </am-card-filter>
          }
        }
        @case ('OFFERS') {
          @if (brand) {
            <am-card-filter class="filter__offers" [type]="filter.type" icon="discount-rate" [brand]="brand">
              <div class="filter__panel__content">
                <am-checkbox-list (valueChange)="changeFilter($event.isChecked, $event.type, $event.item)"
                  [type]="filter?.type" [options]="filter?.values" [appliedParams]="queryParams"
                  [appliedFilters]="appliedFilters"></am-checkbox-list>
              </div>
            </am-card-filter>
          }
        }
        @default {
          <div class="filter" [id]="filter.type" [class.--margin-top]="i === 0" [class.--last]="isLast && isMobile">
            <mb-expandable-panel class="filter__panel" [expanded]="true" id="{{filter.type}}" #filterContentPanel>
              @switch (filter.type) {
                @case ('PRICE_RANGE') {
                  <div class="filter__panel__content --price-range">
                    <ng-template #sliderLabel let-value>
                      @if (currencyCode === 'USD') {
                        {{ value | currency: 'u$s' :'code' }}
                      } @else {
                        {{ value | currency: '$' :'code' }}
                      }
                    </ng-template>
                    <mb-slider-range (rangeChange)="changeFilter(null, filter?.type, $event)"
                      [minLimit]="priceRange?.min && priceRange?.min < filter?.from ? priceRange?.min : filter?.from"
                      [maxLimit]="priceRange?.max && priceRange?.max > filter?.to ? priceRange?.max : filter?.to"
                      [min]="priceRange?.min || filter?.from" [max]="priceRange?.max || filter?.to" [label]="sliderLabel">
                    </mb-slider-range>
                  </div>
                }
                @case ('NAME') {
                  <mb-form-field class="--padding-bottom" appearance="light">
                    <input [(ngModel)]="filterNameValue" mb-form-field-input type="text"
                      placeholder="Ingrese el nombre del alojamiento" i18n-placeholder="@@filters__name-filter"
                      (focus)="onFocus(true)" (blur)="onFocus(false)" />
                    <mb-icon mb-form-field-suffix class="clickable" (click)="changeFilter(null, filter?.type, null)"
                      icon="len"></mb-icon>
                  </mb-form-field>
                }
                @case ('CURRENCY') {
                  <div class="filter__panel__content">
                    <mb-radio-group [(value)]="currencyCode" [disabled]="isCurrencyDisabled">
                      <ul>
                        @for (item of filter.values; track item; let i = $index) {
                          <li>
                            <mb-radio [value]="item.code" (click)="redirectChangeCurrency(item.code)">{{ item.name
                              }}</mb-radio>
                          </li>
                        }
                      </ul>
                    </mb-radio-group>
                  </div>
                }
                @default {
                  <div class="filter__panel__content">
                    <am-checkbox-list (valueChange)="changeFilter($event.isChecked, $event.type, $event.item)"
                      [type]="filter?.type" [options]="filter?.values" [appliedParams]="queryParams"
                      [appliedFilters]="appliedFilters"></am-checkbox-list>
                  </div>
                }
              }
            </mb-expandable-panel>
            <button class="filter__header" [mb-expandable-panel]="filterContentPanel">
              <span class="filter__header__content">
                <span class="filter__header__text" i18n="@@filters__item__title">
                  {filter.title, select, RECOMMENDED {Filtros más usados} NAME {Nombre del hotel} PRICE_RANGE {Precio}
                  STAR {Estrellas} MEAL {Plan de comida} PAYMENT_METHOD {Método de pago} ACCOMMODATION_TYPE {Tipo de
                  alojamiento} RATING {Puntuación} AMENITY {Servicios} NEARBY {Lugares de interés} DISCOUNTS {Descuentos}
                  CURRENCY {Moneda}}
                </span>
                <mb-icon class="filter__header__arrow" icon="arrow-up"
                  [verticalFlip]="!filterContentPanel.expanded()"></mb-icon>
              </span>
            </button>
          </div>
        }
      }
    }
  </div>
  @if (isMobile) {
    <div class="filters__footer">
      <button class="--button-fullwidth" mb-button variant="principal" color="primary" [disabled]="!hasFiltersChanged"
        (click)="dispatch()">
        <span i18n="@@filters__apply">Aplicar</span>
      </button>
    </div>
  }
</section>